/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateEtcCardIssuanceRequest500Response
 */
export interface CreateEtcCardIssuanceRequest500Response {
    /**
     * 
     * @type {string}
     * @memberof CreateEtcCardIssuanceRequest500Response
     */
    'code': CreateEtcCardIssuanceRequest500ResponseCodeEnum;
}

export const CreateEtcCardIssuanceRequest500ResponseCodeEnum = {
    validationError: 'etc-validation-error',
    cardNameDuplicate: 'etc-card-name-duplicate',
    cardLimitExceeded: 'etc-card-limit-exceeded',
    creditInsufficient: 'etc-credit-insufficient',
    issuerPermissionDenied: 'etc-issuer-permission-denied',
    issuerNotFound: 'etc-issuer-not-found',
    holderInvalidRole: 'etc-holder-invalid-role',
    holderNotFound: 'etc-holder-not-found',
    systemError: 'etc-system-error'
} as const;

export type CreateEtcCardIssuanceRequest500ResponseCodeEnum = typeof CreateEtcCardIssuanceRequest500ResponseCodeEnum[keyof typeof CreateEtcCardIssuanceRequest500ResponseCodeEnum];


